import { render, staticRenderFns } from "./NavCallUs.vue?vue&type=template&id=0a3917ba"
import script from "./NavCallUs.vue?vue&type=script&lang=ts"
export * from "./NavCallUs.vue?vue&type=script&lang=ts"
import style0 from "./NavCallUs.vue?vue&type=style&index=0&id=0a3917ba&prod&lang=css&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PhoneNumber: require('/app/components/generic/PhoneNumber.vue').default})
